import { render } from "./errorPage3.vue?vue&type=template&id=8a051f22&scoped=true"
const script = {}

import "./errorPage3.vue?vue&type=style&index=0&id=8a051f22&lang=scss&scoped=true"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a051f22"]])

export default __exports__